// extracted by mini-css-extract-plugin
export default {"button":"Button_button__aH-lN","primary-button":"Button_primary-button__q0Eqf","secondary-button":"Button_secondary-button__9auf7"};